// extracted by mini-css-extract-plugin
export default {"dashboard":"FinancesSection_dashboard__P1VJr"};